import { PERMISSION_RESOURCE_CODES as R } from '../../src/permissions/definitions';
import type { AppRoute } from '../routes';

const boundary = '@/modules/zy-hr/EmployeeDomainBoundary';
const base = '/social-insurance-center';
const page = (
  suffix: string,
  name: string,
  resource: string,
  component: string,
  icon?: string,
): AppRoute => ({
  path: `${base}${suffix}`,
  name,
  icon,
  permissionResourceCode: resource,
  component: `./zy-hr/${component}`,
});
const detail = (
  suffix: string,
  resource: string,
  component: string,
  parent: string,
): AppRoute => ({
  ...page(suffix, '', resource, component),
  hideInMenu: true,
  parentKeys: [base, `${base}${parent}`],
});

export const socialInsuranceRoutes: AppRoute[] = [
  {
    path: base,
    name: '社保中心',
    icon: 'safety',
    wrappers: [boundary],
    routes: [
      {
        path: `${base}/`,
        hideInMenu: true,
        component: './Platform/OverviewRedirect',
      },
      page(
        '/overview',
        '概览',
        R.socialInsuranceWorkbench,
        'SocialInsuranceWorkbench',
        'dashboard',
      ),
      page(
        '/approval',
        '我的审批',
        R.socialInsuranceApproval,
        'SocialInsuranceApprovalCenter',
        'audit',
      ),
      {
        path: '',
        key: 'social-insurance-management',
        name: '参保管理',
        icon: 'team',
        routes: [
          page(
            '/changes',
            '参保办理',
            R.socialInsuranceChanges,
            'SocialInsuranceChangeList',
          ),
          detail(
            '/changes/new',
            R.socialInsuranceChanges,
            'SocialInsuranceChangeForm',
            '/changes',
          ),
          detail(
            '/changes/:uuid/edit',
            R.socialInsuranceChanges,
            'SocialInsuranceChangeForm',
            '/changes',
          ),
          detail(
            '/changes/:uuid/view',
            R.socialInsuranceChanges,
            'SocialInsuranceChangeForm',
            '/changes',
          ),
          page(
            '/accounts',
            '参保档案',
            R.socialInsuranceAccounts,
            'SocialInsuranceAccountList',
          ),
          detail(
            '/accounts/:uuid/edit',
            R.socialInsuranceAccounts,
            'SocialInsuranceAccountForm',
            '/accounts',
          ),
          detail(
            '/accounts/:uuid/view',
            R.socialInsuranceAccounts,
            'SocialInsuranceAccountForm',
            '/accounts',
          ),
        ],
      },
      page(
        '/bills',
        '社保缴费',
        R.socialInsuranceBills,
        'SocialInsuranceBillList',
        'accountBook',
      ),
      detail(
        '/bills/:uuid',
        R.socialInsuranceBills,
        'SocialInsuranceBillList',
        '/bills',
      ),
      {
        ...page(
          '/team',
          '团队社保',
          R.socialInsuranceTeam,
          'SocialInsuranceTeam',
        ),
        hideInMenu: true,
      },
      page(
        '/audits',
        '操作记录',
        R.socialInsuranceAudits,
        'SocialInsuranceAuditList',
        'history',
      ),
      {
        path: '',
        key: 'social-insurance-settings',
        name: '社保设置',
        icon: 'setting',
        routes: [
          page(
            '/policies',
            '参保方案',
            R.socialInsurancePolicies,
            'SocialInsurancePolicyList',
          ),
          detail(
            '/policies/new',
            R.socialInsurancePolicies,
            'SocialInsurancePolicyForm',
            '/policies',
          ),
          detail(
            '/policies/:uuid/edit',
            R.socialInsurancePolicies,
            'SocialInsurancePolicyForm',
            '/policies',
          ),
          detail(
            '/policies/:uuid/view',
            R.socialInsurancePolicies,
            'SocialInsurancePolicyForm',
            '/policies',
          ),
          page(
            '/workflow-settings',
            '审批流程设置',
            R.socialInsuranceWorkflowSettings,
            'SocialInsuranceWorkflowSettings',
          ),
        ],
      },
    ],
  },
];
